import * as React from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import { RelodeTheme, baseColors } from "@relode/core";
import { MemberUpcomingInterview } from "../_infra/types";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            columnSubText: {
                fontSize: ".75rem",
                color: baseColors.gray,
            },
            columnMultiRow: {
                display: "flex",
                flexDirection: "column",
            },
        }),
    { name: "UpcomingInterviewDateColumn" }
);

export const UpcomingInterviewDateColumn = (props: {
    data: MemberUpcomingInterview;
}) => {
    const classes = useStyles({});
    return (
        <div className={classes.columnMultiRow}>
            <span>{props.data.interviewDate}</span>
            <span className={classes.columnSubText}>
                {props.data.interviewTimeSpan}
            </span>
        </div>
    );
};
